import React from 'react';
import { FaIcon } from '../FaIcon';
import { getFieldDescriptionKey } from '../../utils/fieldDescriptions';
import { withTranslation } from 'react-i18next';

class FieldHelpIconComponent extends React.Component {
    handleMouseEnter = (e) => {
        const tooltip = e.currentTarget.querySelector('.field-help-tooltip');
        if (tooltip) {
            const rect = e.currentTarget.getBoundingClientRect();
            tooltip.style.display = 'block';
            tooltip.style.position = 'fixed';
            tooltip.style.top = `${rect.bottom + 5}px`;
            tooltip.style.left = `${rect.left + rect.width / 2}px`;
            tooltip.style.transform = 'translateX(-50%)';
            tooltip.style.zIndex = '100000';
        }
    };

    handleMouseLeave = (e) => {
        const tooltip = e.currentTarget.querySelector('.field-help-tooltip');
        if (tooltip) {
            tooltip.style.display = 'none';
        }
    };

    render() {
        const { fieldId, t } = this.props;
        const descriptionKey = getFieldDescriptionKey(fieldId);
        
        if (!descriptionKey) {
            return null;
        }
        
        return (
            <span 
                className="field-help-icon-container"
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <FaIcon iconName="question-circle" className="field-help-icon" />
                <span className="field-help-tooltip">
                    <span className="tooltip-description">{t(descriptionKey)}</span>
                </span>
            </span>
        );
    }
}

export const FieldHelpIcon = withTranslation()(FieldHelpIconComponent);

